import { Dispatch, SetStateAction } from 'react';
import {
  AuthenticateUser,
  USER_INFO,
  SystemSettingModelType,
  GetLoginMode,
  SendPasswordInfo,
  SendMailAction,
  OnetimeAuthenticate, EntryMailAdressInfo,
  EntryMailAction,
  GetLogoutMode
} from './function/UserManageModel';

/**
 * セッション保存情報
 */
type SaveSession = {
  id: string;
  userName: string;
  setAuth: boolean;
  systemAuth: boolean;
  repAuth: boolean;
  isIoT: boolean;
  systemSettingModel: SystemSettingModelType;
}


const SessionKey: string = "Rolling";

export class LoginState {
  private _UserName: string = "";
  private _ID: string = "";
  private _IsLogin: boolean = false;
  private _SET_AUTH: boolean = false;
  private _REP_AUTH: boolean = false;
  private _SYSTEM_AUTH: boolean = false;
  private _IsIoT: boolean = false;
  private _SystemSettingModel: SystemSettingModelType = {
    ThreeDButtonEnabled: 0,
    ReportButtonEnabled: 0,
    OffLineJudgeButtonEnabled: 0,
    ConanairEnabled: 0,
    EmcbEnabled: 0,
    PartialDischargeEnabled: 0,
    OnetimePasswordEnable: 0,
  };
  private _dispatch: Dispatch<SetStateAction<boolean>>;

  private static _instance: LoginState;

  /**
   * ユーザー名
   */
  get UserName(): string {
    return this._UserName;
  }

  /**
   * ユーザーID
   */
  get ID(): string {
    return this._ID;
  }

  /**
   * ログイン状態
   */
  get IsLogin(): boolean {
    return this._IsLogin;
  }

  get SET_AUTH(): boolean {
    return this._SET_AUTH;
  }

  get REP_AUTH(): boolean {
    return this._REP_AUTH;
  }

  get IsIoT(): boolean {
    return this._IsIoT;
  }
  get SYSTEM_AUTH(): boolean {
    return this._SYSTEM_AUTH;
  }

  /**
   * システム設定
   */
  get GetSystemSettingModel(): SystemSettingModelType {
    return this._SystemSettingModel;
  }

  public static getInstance(dispatch: Dispatch<SetStateAction<boolean>>): LoginState {
    if (!this._instance) {
      this._instance = new LoginState(dispatch);
    }

    return this._instance;
  }

  private constructor(dispatch: Dispatch<SetStateAction<boolean>>) {
    console.log('LoginState ctor');
    this._dispatch = dispatch;

    let sessionStr = sessionStorage.getItem(SessionKey);
    //console.debug('LoginState ctor -- sessionStr:', sessionStr);
    if (sessionStr) {
      // セッションに保存されているときは復元しログイン情報とする
      let session: SaveSession = JSON.parse(sessionStr);
      this._ID = session.id;
      this._UserName = session.userName;
      this._SET_AUTH = session.setAuth;
      this._SYSTEM_AUTH = session.systemAuth;
      this._REP_AUTH = session.repAuth;
      this._IsIoT = session.isIoT;
      this._SystemSettingModel = session.systemSettingModel;
      this._IsLogin = true;
      this._dispatch(this._IsLogin);
    }
  }

  /**
   * ログイン処理
   * @param id ユーザーID
   * @param pw パスワード
   * @returns ログイン成功時true
   */
  login(id: string, pw: string): Promise<USER_INFO> {
    return new Promise<USER_INFO>((resolve, reject) => {
      AuthenticateUser(id, pw)
        .then((result: USER_INFO) => {
          console.log('userResp', result);
          this._IsLogin = result.USER_ID?.toUpperCase() === id.toUpperCase();
          console.debug(`this._IsLogin : ${this._IsLogin}, result.USER_ID : ${result.USER_ID}, id : ${id}`);

          this._ID = result.USER_ID;
          this._UserName = result.USER_NAME;
          this._SET_AUTH = result.SET_AUTH;
          this._SYSTEM_AUTH = result.SYSTEM_AUTH;
          this._REP_AUTH = result.REP_AUTH;
          this._IsIoT = result.IS_IOT;
          this._SystemSettingModel = result.SystemSettingModel;

          this._dispatch(this._IsLogin);
          console.log('username [', this.UserName, ']');

          let saveSession: SaveSession = {
            id: this._ID,
            userName: this._UserName,
            setAuth: this._SET_AUTH,
            repAuth: this._REP_AUTH,
            systemAuth: this._SYSTEM_AUTH,
            isIoT: this._IsIoT,
            systemSettingModel: this._SystemSettingModel,
          }
          sessionStorage.setItem(SessionKey, JSON.stringify(saveSession));

          resolve(result);
        })
        .catch(reason => reject(reason));
    });
  }

  /**
   * ログアウト処理
   */
  logout() {
    return new Promise<boolean>((resolve, reject) => {
      GetLogoutMode()
        .then((result: boolean) => {
          console.log('GetLogoutMode', result);

          resolve(result);
          this._IsLogin = false;
          this._dispatch(false);

          sessionStorage.removeItem(SessionKey);
        })
        .catch(reason => reject(reason));
    });

  }

  /**
   * 2段階認証処理が有効か確認する処理
   * @returns 
   */
  loginMode() {
    return new Promise<boolean>((resolve, reject) => {
      GetLoginMode()
        .then((result: boolean) => {
          console.log('GetLoginMode', result);


          resolve(result);
        })
        .catch(reason => reject(reason));
    });
  }

  /**
   * 2段階認証パスワード送信処理
   * @param id 
   * @param pw 
   * @returns 
   */
  sendPassword(id: string, pw: string) {
    return new Promise<SendPasswordInfo>((resolve, reject) => {
      SendMailAction(id, pw)
        .then((result: SendPasswordInfo) => {
          console.log('sendPassword', result);

          this._ID = result.USER_ID;

          resolve(result);
        })
        .catch(reason => reject(reason));
    });
  }

  /**
   * 2段階認証 ログイン処理
   * @param id 
   * @param pw 
   * @returns 
   */
  onetimeLogin(id: string, pw: string): Promise<USER_INFO> {
    return new Promise<USER_INFO>((resolve, reject) => {
      OnetimeAuthenticate(id, pw)
        .then((result: USER_INFO) => {
          console.log('userResp', result);
          this._IsLogin = result.USER_ID?.toUpperCase() === id.toUpperCase();
          console.debug(`this._IsLogin : ${this._IsLogin}, result.USER_ID : ${result.USER_ID}, id : ${id}`);

          this._ID = result.USER_ID;
          this._UserName = result.USER_NAME;
          this._SET_AUTH = result.SET_AUTH;
          this._SYSTEM_AUTH = result.SYSTEM_AUTH;
          this._REP_AUTH = result.REP_AUTH;
          this._IsIoT = result.IS_IOT;
          this._SystemSettingModel = result.SystemSettingModel;

          this._dispatch(this._IsLogin);
          console.log('username [', this.UserName, ']');

          let saveSession: SaveSession = {
            id: this._ID,
            userName: this._UserName,
            setAuth: this._SET_AUTH,
            repAuth: this._REP_AUTH,
            systemAuth: this._SYSTEM_AUTH,
            isIoT: this._IsIoT,
            systemSettingModel: this._SystemSettingModel,
          }
          sessionStorage.setItem(SessionKey, JSON.stringify(saveSession));

          resolve(result);
        })
        .catch(reason => reject(reason));
    });
  }

  /**
   * メールアドレス登録処理
   * @param user 
   * @param adress 
   * @returns 
   */
  entryAdress(user: string, adress: string) {
    return new Promise<EntryMailAdressInfo>((resolve, reject) => {
      EntryMailAction(user, adress)
        .then((result: EntryMailAdressInfo) => {
          console.log(['entryAdress --result', result]);

          resolve(result);
        }).catch(reason => reject(reason));
    });
  }

}
